<template>
  <b-modal v-model="show" centered size="md">
    <template #modal-title>
      <h3 class="font-weight-bold">
        {{
          viewOnly ? `${templateLabel} already on file` : 'File already exists'
        }}
      </h3>
    </template>

    <b-row class="mb-3">
      <b-col>
        <template v-if="files.length > 1">
          {{ subject }}
          <strong>{{ files.length }} {{ templateLabel }}</strong> files.
          {{
            viewOnly
              ? 'Select one to view, or request anyway.'
              : 'Select one to edit, or create a new one.'
          }}
        </template>
        <template v-else>
          {{ subject }} a <strong>{{ templateLabel }}</strong> file.
          {{
            viewOnly
              ? 'View it, or request anyway.'
              : 'Edit it, or create a new one.'
          }}
        </template>
      </b-col>
    </b-row>

    <existing-file-list
      :files="files"
      :show-company-approval="showCompanyApproval"
      :view-only="viewOnly"
      @edit="$emit('edit', $event)"
      @view="$emit('view', $event)"
    />

    <template #modal-footer>
      <div class="d-flex w-100" style="gap: 16px">
        <b-button
          block
          class="m-0 btn-outlined bg-white text-dark"
          variant="outline-secondary"
          @click="$emit('createNew')"
        >
          {{ viewOnly ? 'Request anyway' : 'Create new file' }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ExistingFileList from '@/components/lists/ExistingFileList'

export default {
  name: 'ExistingFileModal',

  components: {
    ExistingFileList,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      default: () => [],
    },
    templateLabel: {
      type: String,
      default: 'file',
    },
    subject: {
      type: String,
      default: 'You already have',
    },
    showCompanyApproval: {
      type: Boolean,
      default: false,
    },
    // Request-a-file warning: the viewer can only look at the files, not edit
    // them, and the footer action sends another request instead of creating a
    // file.
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('close')
      },
    },
  },
}
</script>
